import { useEffect } from 'react';
import classnames from 'classnames';
import { useLocation } from 'react-router-dom';
import useSound from 'use-sound';

import {
    useAssetsLoaded,
    useUI,
    useEntering,
    useLoading,
    useTransition,
    useSoundOn,
    useMapReady,
    useRedirectPath,
} from 'models/mainSite';
import { useAuth } from 'models/auth';

import { usePreloadImages } from 'utils/hooks';
import { main as preloadAssets } from 'utils/preloadAssets';
import storage from 'utils/storage';

import UserControlTop from 'components/molecules/UserControlTop';
import UserControlBottom from 'components/molecules/UserControlBottom';
import UserControlRight from 'components/molecules/UserControlRight';

import siteSound from 'audio/site.mp3';

import styles from './index.css';

export interface MainProp {
    className?: string;
}

const Main: React.FC<MainProp> = ({ children }) => {
    const { pathname } = useLocation();

    const [soundOn] = useSoundOn();

    const [mapReady] = useMapReady();

    const [playSound, { stop: stopSound, pause }] = useSound(siteSound, {
        preload: true,
        loop: true,
        volume: 0.4,
        soundEnabled: soundOn,
    });

    useEffect(() => {
        if (soundOn && pathname !== '/' && !pathname.includes('/events/')) {
            pause();
            playSound();
        } else {
            pause();
        }
    }, [soundOn, playSound, pause, pathname]);

    const { completed: preloadComplete } = usePreloadImages(preloadAssets);

    const [, { setAssetsLoaded }] = useAssetsLoaded();
    const [, { setEnteringView }] = useEntering();
    const [, { setLoading }] = useLoading();
    const [{ active: transitionActive }] = useTransition();
    const [{ hide: hideUI }] = useUI();
    const [, { setRedirectPath }] = useRedirectPath();

    const [, { setLoginType, login }] = useAuth();

    useEffect(() => {
        const token = storage.getItem('token');
        if (token) {
            // TODO change this
            setLoginType('facebook');
        } else {
            setRedirectPath(pathname);
        }
        // else if (pathname !== '/' && !pathname.startsWith('/share')) {
        //     login({
        //         type: 'visitor',
        //     });
        // }
    }, []);

    // useEffect(() => {
    //     setRedirectPath(pathname);
    // }, []);

    useEffect(() => {
        if (preloadComplete) {
            setAssetsLoaded('main');
            setLoading(false);
            setEnteringView('beforeLogin');
        }
    }, [preloadComplete]);

    return (
        <>
            {pathname !== '/' && !transitionActive && (
                <UserControlRight className={classnames(styles.uiRight, hideUI && styles.hide)} />
            )}
            {children}
            {pathname !== '/' && !transitionActive && (
                <UserControlTop
                    className={classnames(
                        styles.uiTop,
                        (pathname.includes('/en') || hideUI) && styles.hide,
                    )}
                />
            )}
            {pathname !== '/' && !transitionActive && (
                <UserControlBottom
                    className={classnames(
                        styles.uiBottom,
                        (pathname.includes('/en') || hideUI) && styles.hide,
                    )}
                />
            )}
        </>
    );
};

export default Main;
